import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import Breadcrums from "../../../common/breadcrumbs";
import { globalLoader, handleServerValidations } from "../../../../../utils/commonfunction";
import CustomError from "../../../../../utils/customError";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import CustomCkeditor from "../../../common/customeditor";
import { Tooltip, Whisper } from "rsuite";
import Loader from "../../../common/loader";
import { AboutUsDetails, AddAboutUs } from "../../../services/aboutUs";
import { AddExpertGuidance, ExpertGuidanceDetails } from "../../../services/expertGuidance";

const ExpertGuidance = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [defaultData, setDefaultData] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const breadcrumbs = [
        { title: t("Dashboard"), url: "/admin/dashboard/1" },
        { title: t("Add About Us"), url: "" },
    ];

    useEffect(() => {
        ExpertGuidanceDetails()
            .then((response) => {
                setDefaultData(response?.data);
                setPreviewImage(response?.data?.image);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);

    console.log("defaultData-->", defaultData);

    const validationSchema = Yup.object().shape({
        question_title: Yup.string().trim().max(100, "max_length_error").required("Option is required"),
        question_description: Yup.string().trim().max(500, "max_length_error"),
        question_type: Yup.string().trim().max(100, "Cannot exceed 100 words").required("Question type is required"),
        option: Yup.array()
            .min(1, "At least one option is required")
            .of(
                Yup.object({
                    option_slug: Yup.string().min(1, "Option slug cannot be empty").required("Option slug is required"),
                    option_value: Yup.string().min(1, "Option value cannot be empty").required("Option value is required"),
                })
            )
            .required("Option array is required"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: defaultData && defaultData.title ? defaultData.title : "",
            content: defaultData && defaultData.content ? defaultData.content : "",
            image: defaultData && defaultData.image ? defaultData.image : "",
            options: defaultData && defaultData.options ? defaultData.options : [{ option: "" }],
        },
        validateOnBlur: false,
        // validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("title", values.title);
            formData.append("content", values.content);
            formData.append("image", values.image);
            formData.append("options", JSON.stringify(formik.values?.options));

            AddExpertGuidance(formData)
                .then((response) => {
                    setSubmitting(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        // resetForm({ values: "" });
                        // navigate(`/admin/cms/about-us`);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        setSubmitted(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        },
    });

    const handleAddOption = () => {
        formik.setFieldValue("options", [...formik.values.options, { option: "" }]);
    };

    const handleRemoveOption = (index) => {
        const newOptions = formik.values.options.filter((_, i) => i !== index);
        formik.setFieldValue("options", newOptions);
    };

    console.log("value--->", formik.values);
    console.log("errors--->", formik.errors);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (
                <form onSubmit={formik.handleSubmit}>
                    <div className="row row-sm">
                        <div className="col-lg-12 col-md-12 animation_fade">
                            <div className="card custom-card">
                                <div className="card-body">
                                    <div>
                                        <h6 className="main-content-label mb-3">{t("About Us")}</h6>
                                    </div>
                                    <div className="row row-sm">
                                        <div className="col-md-6 text-center form-group">
                                            <label htmlFor="title" className="text-left d-flex">
                                                Title:
                                                <span className="requirestar">*</span>{" "}
                                            </label>
                                            <input
                                                name="title"
                                                id="title"
                                                type="text"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.title}
                                                className="form-control"
                                                placeholder="Enter Title"
                                            />
                                            <span className="text-danger d-flex text-left">
                                                <CustomError name="title" form={formik} />
                                            </span>
                                        </div>

                                        <div className="col-lg-12 text-center form-group">
                                            <label htmlFor="content" className="text-left d-flex">
                                                Content:<span className="requirestar">*</span>
                                            </label>
                                            <CustomCkeditor fieldname={"content"} setFieldValue={formik.setFieldValue} value={formik.values.content} setFieldTouched={formik.setFieldTouched} />
                                            <span className="text-danger d-flex text-left">{formik.errors.content && formik.touched.content && formik.errors.content}</span>
                                        </div>

                                        <div className="col-lg-6 text-center form-group">
                                            <label htmlFor="image" className="text-left d-flex">
                                                Image:{" "}
                                                <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("Please upload an image in 496px width × 479px height")}</Tooltip>}>
                                                    <span className="field-more-info mt-1 ms-1 cp"> ? </span>
                                                </Whisper>
                                                <small className="text-muted d-block mt-1 ms-2">
                                                    Please upload an image in{" "}
                                                    ({" "}
                                                    <code>
                                                        {496}px width × {479}px height
                                                    </code>
                                                    ).
                                                </small>
                                            </label>
                                            <input
                                                className="form-control imgInput"
                                                id="image"
                                                name="image"
                                                accept="image/*"
                                                type="file"
                                                onChange={(event) => {
                                                    formik.setFieldValue("image", event.target.files[0] || "");
                                                    event.target.files.length === 1 ? setPreviewImage(URL.createObjectURL(event.target.files[0])) : setPreviewImage("");
                                                }}
                                            />
                                            <span className="text-danger d-flex text-left">
                                                <CustomError name="image" form={formik} />
                                            </span>

                                            {previewImage ? (
                                                <ul className="question-image-preview questions-ul">
                                                    <li className="pr_img_box">
                                                        <img src={previewImage} style={{ height: "100px" }} alt={"Profile_Img"} />
                                                        <div className="img_options">
                                                            <button
                                                                type="button"
                                                                className="text-danger"
                                                                onClick={() => {
                                                                    // console.log(previewResImage , previewImage)
                                                                    setPreviewImage("");
                                                                    formik.setFieldValue("image", null);
                                                                    document.getElementById("image").value = "";
                                                                }}
                                                            >
                                                                <i className="ri-delete-bin-6-fill"></i>
                                                            </button>
                                                        </div>
                                                    </li>
                                                </ul>
                                            ) : (
                                                ""
                                            )}
                                        </div>

                                        <hr></hr>
                                        <h3 className="mt-4">Options</h3>
                                        {formik?.values?.options?.map((option, index) => (
                                            <div key={index} className="row">
                                                <div className="col-md-6 text-center form-group">
                                                    <label htmlFor={`option${index}`} className="text-left d-flex">
                                                        Option:
                                                        <span className="requirestar">*</span>{" "}
                                                    </label>
                                                    <input
                                                        name={`options[${index}].option`}
                                                        id={`option${index}`}
                                                        type="text"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={option.option}
                                                        className="form-control"
                                                        placeholder={t("Enter option")}
                                                    />
                                                    {/* <span className="text-danger d-flex text-left">
                                                        <CustomError name={`option[${index}].option_title`} form={formik} />
                                                        </span> */}
                                                    {/* <span className='text-danger d-flex text-left'>{formik.errors.option[index].option_title && formik.touched.option[index].option_title && formik.errors.option[index].option_title}</span> */}
                                                </div>

                                                {/* ===============Image section end================= */}
                                                <div className="col-md-6 text-center form-group"></div>

                                                {/* Remove Option Button */}
                                                {index === formik.values.options?.length - 1 && (
                                                    <div className="col-md-1 mb-4 text-center align-content-center">
                                                        <button type="button" className="btn btn-danger" onClick={() => handleRemoveOption(index)}>
                                                            {t("Remove")}
                                                        </button>
                                                    </div>
                                                )}
                                                {/* Add Option Button */}
                                                {index === formik.values.options?.length - 1 && (
                                                    <div className="col-md-1 mb-4 text-center align-content-center">
                                                        <button type="button" className="btn btn-success w-100" onClick={handleAddOption}>
                                                            {t("Add")}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        ))}

                                        <div className="mt-5">
                                            <button
                                                className="btn btn-info mr-2"
                                                type="submit"
                                                // disabled={submitted ? true : null}
                                            >
                                                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                Submit
                                            </button>
                                            <button
                                                className="btn ripple btn-secondary"
                                                type="button"
                                                // disabled={submitted ? true : null}
                                                onClick={() => navigate(-1)}
                                            >
                                                <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default ExpertGuidance;
